"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";

/**
 * Граница ошибок локализованной ветки. Без неё падение любого клиентского острова
 * (галерея, лайтбокс, карта) роняет страницу в дефолтный экран Next: без бренда,
 * без телефона и без кнопки «попробовать снова».
 */
export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  const t = useTranslations("errorPage");

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-[70vh] max-w-[1280px] flex-col items-start justify-center gap-6 px-[clamp(20px,4vw,40px)]">
      <p className="text-xs tracking-[.2em] text-accent uppercase">{t("kicker")}</p>
      <h1 className="max-w-[18ch] text-[clamp(28px,3.4vw,44px)] leading-[1.12]">{t("title")}</h1>
      <p className="max-w-[46ch] text-[16px] leading-[1.72] font-light text-muted">{t("body")}</p>
      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          onClick={reset}
          className="rounded-[3px] bg-accent px-5 py-3.5 text-[14px] font-medium text-white transition-colors hover:bg-ink"
        >
          {t("retry")}
        </button>
        <a
          href="tel:+66979060999"
          className="rounded-[3px] border border-ink/[.16] px-5 py-3.5 text-[14px] font-medium text-ink transition-colors hover:border-ink/40"
        >
          +66 97 906 09 99
        </a>
      </div>
    </main>
  );
}
